import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import actions from '../actions/CongratulationsApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import {getSubmitResponse} from './ApplicationsAPI';
import ErrorHandler from '../core/ErrorHandler.js';

module.exports = {
    downloadAll: function(formModel, productCode) {
        let url = APIUrl.DOWNLOAD_ALL.replace('{pid}', productCode).replace('{aid}', formModel.id);
        let formData = { application: formModel, transactions: getSubmitResponse() };
        const data = JSON.stringify(formData);
        axios.post(url, data)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                actions.downloadAllResponse(response.data, false);
            })
            .catch((error) => {
                actions.downloadAllResponse(null, true);
                ErrorHandler.logError(Error('download All', error));
            });
    },

    downloadFile: function(formModel, productCode, formId) {
        let id = formId.split('__');
        let url = APIUrl.DOWNLOAD_FORM_URL;
        if (id && id.length == 2) {
            url = url.replace('{pid}', productCode).replace('{fid}', id[0]).replace('{filter}', id[1]);
        } else {
            url = url.replace('{pid}', productCode).replace('{fid}', formId).replace('{filter}', '');
        }

        let formData = { application: formModel, transactions: getSubmitResponse() };
        const data = JSON.stringify(formData);
        axios.post(url, data)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                actions.downloadFormSuccess(response.data);
            })
            .catch((error) => {
                actions.downloadFormFailed();
                ErrorHandler.logError(Error('download file', error));
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/CongratulationsApi.js